import React from 'react'
import BookingListItem, { BookingListItemProps } from './booking_list_item'
import List from '../../components/list'

interface BookingListProps {
  bookings: BookingListItemProps[]
}

const BookingList: React.FC<BookingListProps> = ({
  bookings
}) => {
  return (
    <List>
      {bookings.map((booking) => (
        <BookingListItem
          key={booking.studioId}
          {...booking}
        />
      ))}
    </List>
  )
}

export default BookingList
